// Shared, non-component definitions for the "Your organization context" feature, kept out of
// the component files so both OrgContextDrawer and GeneralSettings can import them without
// tripping react-refresh's "only export components" rule.

export interface OrgContextValues {
  description: string;
  idealCompanyProfile: string;
  idealPersonProfile: string;
}

export interface OrgContextField {
  key: keyof OrgContextValues;
  namespace: "description" | "company" | "person";
}

// Single source of truth for the org-context field set: their order and their i18n namespace
// segment under `settings.general.orgContext`. Both the drawer and the General settings page
// derive their rows from this list so the two never drift out of sync.
export const ORG_CONTEXT_FIELDS: OrgContextField[] = [
  { key: "description", namespace: "description" },
  { key: "idealCompanyProfile", namespace: "company" },
  { key: "idealPersonProfile", namespace: "person" }
];

// The drawer's open animation is a CSS transition on the vaul surface (no JS duration we can
// read), so callers wait a short beat before focusing the target field to let it settle.
export const FOCUS_AFTER_OPEN_DELAY_MS = 150;

// Scroll a field's wrapper into view and focus its editor. The textarea is rendered a couple
// of layers down by SettingItemLayout (which exposes no ref), so we reach it via querySelector
// on the field's own wrapper element. focus() uses preventScroll because scrollIntoView above
// already positions the field — a second, browser-driven focus scroll would fight it. Null
// container (field not mounted yet) is a safe no-op.
export const focusOrgContextField = (
  container: HTMLElement | null | undefined
): void => {
  container?.scrollIntoView({ block: "start", behavior: "smooth" });
  container?.querySelector("textarea")?.focus({ preventScroll: true });
};
